<template>
  <div>
    <content-panel class="panel-tabs">
      <el-tabs v-model="activeName" class="tabs">
        <el-tab-pane :label="item.label" v-for="item in tables" :key="item.value" :name="item.value">
          <div slot="label">
            <span>{{ item.label }}</span>
            <el-badge :value="item.number" v-if="item.number"></el-badge>
          </div>
        </el-tab-pane>
      </el-tabs>
      <component :is="activeComponent" @view-details="handleViewDetails" :detailParams="detailParams"></component>
    </content-panel>
  </div>
</template>

<script>
import StoreSummary from './store-summary/StoreSummary';
import PriceChange from './price-change/PriceChange';
import DesignDrawingChange from './design-drawing-change/DesignDrawingChange';
import OtherChange from './other-change/OtherChange';
import BannerImageInfo from './banner-image-info/BannerImageInfo';
import pagePathMixin from '@/utils/page-path-mixin';
export default {
  name: 'FastProductArrival',
  mixins: [pagePathMixin],
  components: { StoreSummary, PriceChange, DesignDrawingChange, OtherChange, BannerImageInfo },
  data() {
    return {
      activeName: 'StoreSummary',
      tables: [
        {
          value: 'StoreSummary',
          label: '店铺汇总',
          number: '',
        },
        {
          value: 'PriceChange',
          label: '价格信息变更',
          number: '',
        },
        {
          value: 'DesignDrawingChange',
          label: '设计图变更',
          number: '',
        },
        {
          value: 'OtherChange',
          label: '其他信息变更',
          number: '',
        },
        {
          value: 'BannerImageInfo',
          label: '通栏图消息',
          number: '',
        },
      ],
      detailParams: null, // 详情传递的参数
    };
  },
  computed: {
    activeComponent() {
      return this.activeName;
    },
  },
  mounted() {
  },
  methods: {
    // 处理详情点击事件
    handleViewDetails(data) {
      const { type, row } = data;
      // type: 1-价格变更, 2-设计图变更, 3-其他信息
      const tabMap = {
        1: 'PriceChange',
        2: 'DesignDrawingChange',
        3: 'OtherChange',
        4: 'BannerImageInfo',
      };
      
      // 切换到对应的tab
      if (tabMap[type]) {
        this.activeName = tabMap[type];
        // 传递详情参数
        this.detailParams = {
          ...row,
          type,
          timestamp: Date.now(), // 添加时间戳确保每次点击都能触发更新
        };
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-tabs
  >>> .main-area
    padding-top 0
.tabs
  >>> .el-tabs__header
    margin-bottom 5px
  >>> .el-badge
        left -4px
  >>> .el-badge__content
        background-color #f56c6c
</style>